//

import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { createOpParams } from '@doda/common/src/logics/JobContent/apiRequest/createOpParams';
import {
  LABEL_FLAG,
  LABEL_NAME,
} from '../../../constants/seo/jobTrendConstants';
import { useAppSelector } from '../../../redux/hooks';

/**
 * フラグとパラメータからどのカテゴリ名を使用するか判定するhooks
 * @param flg
 * @returns カテゴリ名
 */
export const useJudgeForCategory = (flg: string) => {
  const queryParams = useAppSelector(appQueryParamsSelector);
  const hydrogenOp = queryParams.op
    ? createOpParams(queryParams.op)
    : undefined;
  let category;
  switch (flg) {
    case LABEL_FLAG.INCOME:
      if (queryParams.ha) {
        category = LABEL_NAME.INCOME;
      }
      break;
    case LABEL_FLAG.EMPLOYEE_AVERAGE_AGE:
      if (hydrogenOp?.employeeAverageAge) {
        category = LABEL_NAME.EMPLOYEE_AVERAGE_AGE;
      }
      break;
    case LABEL_FLAG.EMPLOYMMENT_STATUS:
      if (hydrogenOp?.employmentStatus) {
        category = LABEL_NAME.EMPLOYMMENT_STATUS;
      }
      break;
    case LABEL_FLAG.ESTABLISH:
      if (queryParams.es) {
        category = LABEL_NAME.ESTABLISH;
      }
      break;
    default:
      category = null;
      break;
  }
  return category;
};
